import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fw-bold d-flex align-items-center text-dark" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-400 fw-semobold fs-6"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" If you need more info, please check out ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://morrisonrecordsbureau.com/contact-us/",
  class: "link-primary fw-bold"
}, "Help Page", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (_ctx.showHelp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : _createCommentVNode("", true)
  ]))
}